import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TabBarContext = /*#__PURE__*/createContext(undefined);
export const TabBarProvider = ({
  buttonWrapperStyleOverrides,
  children,
  tabPanelStyleOverrides,
  tabsStyleOverrides,
  tabBorderStyleOverrides
}) => {
  return /*#__PURE__*/_jsx(TabBarContext.Provider, {
    value: {
      buttonWrapperStyleOverrides,
      tabPanelStyleOverrides,
      tabsStyleOverrides,
      tabBorderStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `TabBar` component.
 * Note: The context is only available when the `TabBar` component is rendered as an ancestor.
 * @returns TabBarContext - The context for the `TabBar` component.
 * @returns TabBarContext.actionsMenuStyleOverrides - Style overrides to be applied to the `ActionsMenu` component.
 * @returns TabBarContext.buttonWrapperStyleOverrides - Style overrides to be applied to the `ButtonWrapper` component.
 * @returns TabBarContext.tabBorderStyleOverrides - Style overrides to be applied to the `Tabs` component.
 */
export const useTabBarContext = () => {
  return useContext(TabBarContext);
};